/** ***********************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2019 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 ************************************************************************* */

import { observable, action } from 'mobx';

export class AppDialogInput {
    id;

    type;

    @observable
    value;

    localizedText;

    ariaLabel;

    disabled;

    additionalData;

    /**
     * Callback to be executed when input value is changed
     * @type {function}
     */
    onChange;

    constructor({
        id, type, value, localizedText, ariaLabel, disabled, onChange = () => {}, additionalData,
    }) {
        this.id = id;
        this.type = type;
        this.value = value;
        this.localizedText = localizedText;
        this.ariaLabel = ariaLabel;
        this.disabled = disabled;
        this.onChange = onChange;
        this.additionalData = additionalData;
    }

    @action
    updateValue = (value) => {
        this.value = value;
        this.onChange(value);
    }
}

export class AppDialogInputLabel {
    constructor(label) {
        this.label = label;
    }
}
